import type { QueryClient } from '@tanstack/react-query';

import { removeAuthToken, removeRole } from 'api/tokenStorage';
import { clearAuthSessionCache } from 'hooks/useAuthSession';
import { useUserStore } from 'modules/Profile/model/user.store';

/**
 * Clears browser-side auth: legacy cookies, role cookies, Zustand user/profile,
 * and React Query caches so the next login cannot reuse the previous account.
 */
export function resetClientAuthState(queryClient?: QueryClient): void {
  removeAuthToken();
  removeRole();
  useUserStore.getState().removeUser();

  try {
    localStorage.removeItem('user');
    localStorage.removeItem('profile');
  } catch {
    // ignore quota / private mode
  }

  clearAuthSessionCache();
  // Prefer targeted clear: wiping everything races RoleGuard with an empty
  // auth cache during role switch / login. When a client is passed, drop all
  // queries then callers (login) re-apply the auth session immediately.
  if (queryClient) {
    queryClient.clear();
  }
}
